import { FC } from 'react';
import { MultiFilterStateContextType } from '../MultiFilter/MultiFilters.types';

import { FiltersPanelSection, PanelFilter } from './FiltersPanelSection';
import { OptionsKeys } from './types';

export type FiltersPanelAllFiltersProps = {
  filtersList: Record<OptionsKeys, PanelFilter[]>;
  updateFilters: (name: keyof MultiFilterStateContextType) => (arr: PanelFilter[]) => void;
  onAdditionalFiltersChange: (arr: PanelFilter[]) => void;
  additionalFilters: PanelFilter[];
  isUtilizationFilter?: boolean;
};

export const getOrdinalSuffix = (n: number) => {
  const suffixes = ['th', 'st', 'nd', 'rd'];
  const value = n % 100;
  return suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0];
};

export const getOrderedCaseLabel = (label: string) => {
  const caseNumber = label.match(/\d+/);
  if (caseNumber) {
    const number = parseInt(caseNumber[0], 10);
    return `${number}${getOrdinalSuffix(number)} Case`;
  }
  return label;
};

export const FiltersPanelAllFilters: FC<FiltersPanelAllFiltersProps> = ({
  filtersList,
  updateFilters,
  onAdditionalFiltersChange,
  additionalFilters,
  isUtilizationFilter = false,
}) => {
  return (
    <div className="overflow-y-auto -mr-8 pr-8">
      {!isUtilizationFilter && (
        <div className="pt-8">
          <FiltersPanelSection
            title=""
            hideSelectAll
            onChange={(data) => onAdditionalFiltersChange(data)}
            filters={additionalFilters}
          />
        </div>
      )}
      <div className="border-t pt-8">
        <FiltersPanelSection
          title="Week Days"
          onChange={updateFilters('weekDay')}
          filters={filtersList.weekOptions}
        />
      </div>
      <div className="border-t pt-8">
        <FiltersPanelSection
          title="Rooms"
          onChange={updateFilters('rooms')}
          filters={filtersList.roomsOptions}
        />
      </div>

      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="Modalities"
            onChange={updateFilters('modalities')}
            filters={filtersList.modalitiesOptions}
          />
        </div>
      )}

      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="Robot Type"
            onChange={updateFilters('robotType')}
            filters={filtersList.robotTypeOptions}
          />
        </div>
      )}

      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="Case Numbers"
            onChange={updateFilters('cases')}
            filters={filtersList.casesOptions.map((c) => {
              return { ...c, label: getOrderedCaseLabel(c.label) };
            })}
          />
        </div>
      )}

      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="Specialties"
            onChange={updateFilters('specialties')}
            filters={filtersList.specialtiesOptions}
          />
        </div>
      )}

      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="Surgeons"
            onChange={updateFilters('surgeons')}
            filters={filtersList.surgeonsOptions}
          />
        </div>
      )}

      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="Procedures"
            onChange={updateFilters('procedures')}
            filters={filtersList.proceduresOptions}
          />
        </div>
      )}

      <div className="border-t pt-8">
        <FiltersPanelSection
          title="Case Counts per Day"
          onChange={updateFilters('casesPerDay')}
          filters={filtersList.casesPerDayOptions}
        />
      </div>

      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="Same Surgeon Turnovers"
            radio
            onChange={updateFilters('sameSurgeon')}
            filters={filtersList.sameSurgeonOptions}
          />
        </div>
      )}
      {!isUtilizationFilter && (
        <div className="border-t pt-8">
          <FiltersPanelSection
            title="All Robotic Days"
            radio
            onChange={updateFilters('allRoboticDay')}
            filters={filtersList.allRoboticDayOptions}
          />
        </div>
      )}
    </div>
  );
};
